import { render } from "./ShorthandUrls.vue?vue&type=template&id=8a2503d8&scoped=true"
import script from "./ShorthandUrls.vue?vue&type=script&lang=js"
export * from "./ShorthandUrls.vue?vue&type=script&lang=js"

import "./ShorthandUrls.vue?vue&type=style&index=0&id=8a2503d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a2503d8"],['__file',"resources/js/components/admin/ShorthandUrls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a2503d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a2503d8', __exports__)) {
    api.reload('8a2503d8', __exports__)
  }
  
  module.hot.accept("./ShorthandUrls.vue?vue&type=template&id=8a2503d8&scoped=true", () => {
    api.rerender('8a2503d8', render)
  })

}


export default __exports__